@if (breadcrumbData().length > 0) {
<nav class="breadcrumb-nav">
  <ul class="breadcrumb-navigation">
    @for (breadcrumb of breadcrumbData(); track breadcrumb.id; let last = $last) {
    <li>
      <a
        class="breadcrumb-label"
        [class.breadcrumb-active]="breadcrumb.id === selectedCategoryId()"
        [routerLink]="['/category', breadcrumb.url]"
        >{{ breadcrumb.name }}
      </a>
    </li>
    @if (!last) {
    <div class="breadcrumb-carrot-icon"></div>
    } }
  </ul>
</nav>
}
